import NextImage, { type ImageProps as NextImageProps } from 'next/legacy/image';
import { forwardRef } from 'react';

import customLoader from '@/utils/imageLoader';

// Using forwardRef to avoid issues with styled-components v5
const Image = forwardRef<HTMLImageElement, NextImageProps>((props, _ref) => {
	if (process.env.IS_STORYBOOK) {
		return <NextImage {...props} unoptimized />;
	}
	return <NextImage {...props} loader={customLoader} />;
});

Image.displayName = 'Image';

export default Image as typeof NextImage;
